import { ITween, ingenuity } from "@quest/base-core";
import { toLocaleMoney, toLocaleNum } from "@quest/murka-games-behavior-leopard/dist/Game/Utils/NumberFormatter";
import { WinTickupMeterBitmap } from "@quest/murka-games-behavior-leopard/dist";
import { gameConstants } from "../Constants/gameConstants";
import { GameParserModel } from "../Platform/GameParserModel";

export class MeterBitmapGame extends WinTickupMeterBitmap {
    // Override to remove value after decimal palace
    public setCurrencyFormattedValue(value: any): void {
        this.value = isNaN(Number(value)) ? Number(value.match(/[0-9]+/g).join(".")) : Number(value);
        const removeAfterDecimalValueArray: string[] = gameConstants.REMOVE_VALUE_AFTER_DECIMAL_PALACE_ON_CURRENCY;
        if (removeAfterDecimalValueArray.indexOf((ingenuity.parserModel as GameParserModel).getCurrencyId()) > -1) {
            this.currencyFormattedValue = toLocaleMoney(this.value, 0);
        } else {
            this.currencyFormattedValue = toLocaleMoney(this.value);
        }
        this.setText(this.currencyFormattedValue);
    }

    public getUpdateCallback(): ITween{
        return this.tickupAnim
    }


    public resetMeter() {
        this.value = 0;
        this.formatedValue = toLocaleNum(this.value.toString());
        this.currencyFormattedValue = toLocaleMoney(this.value);
        this.setText(this.value.toString());
    }
}